module.exports = __webpack_public_path__ + "static/media/ECTAX.12c6809f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/ECTAX.jpg
// module id = 1731
// module chunks = 1